"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetch_1 = __importDefault(require("./fetch"));
exports.default = async () => {
    const response = await fetch_1.default('/location?routable=true');
    if (response.status !== 200) {
        console.error(await response.json());
        throw new Error('TODO(digia): Workout error handling between UI & API with Jules');
    }
    const data = await response.json();
    const { data: locations, meta } = data;
    return { locations, meta };
};
//# sourceMappingURL=fetch-routable-location-list.js.map